import { BaseResponse } from 'src/app/model/api/response/BaseResponse';

export class ApiError extends Error {
  response: BaseResponse;

  constructor(message: string, response: BaseResponse) {
    super(message);

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, ApiError.prototype);

    this.response = response;
  }
}
